import { NestedCheckboxGroupOptionType } from '../../common'

export const resolveLabel = (
    value: string,
    labelsMap: Record<string, string>
): string => labelsMap[value] || value // Resolve label or fallback to value

export const transformDataObject: (
    data: Record<string, unknown>,
    labelsMap: Record<string, string>
) => Array<NestedCheckboxGroupOptionType> = (data, labelsMap) => {
    const processObject = (
        obj: Record<string, unknown>,
        labelPrefix: string = ''
    ): NestedCheckboxGroupOptionType[] => {
        const keys = Object.keys(obj)
        const dataSets: NestedCheckboxGroupOptionType[] = []

        keys.map((key) => {
            const labelKey = `${labelPrefix}${key}`
            const label = labelsMap[labelKey]

            if (label) {
                const dataSet: NestedCheckboxGroupOptionType = {
                    value: labelKey,
                    label: label,
                    children: isNonNullObject(obj[key])
                        ? processObject(obj[key], `${labelKey}_`)
                        : [],
                }

                dataSets.push(dataSet)
            }
        })

        return dataSets
    }

    return processObject(data)
}

const isNonNullObject = (value: unknown): value is Record<string, unknown> => {
    return typeof value === 'object' && value !== null && !Array.isArray(value)
}
